import React from 'react';

import { MenuBar } from './MenuBar';

export const Header: React.FC = () =>
{
  return (
    <header>
      <MenuBar />
    </header>
  );
}